import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const MetaConnectPlatformsPage = lazy(
  () => import('~/features/onboarding/pages/meta-connect-platforms-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/onboarding/integration/meta/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <MetaConnectPlatformsPage />
    </Suspense>
  ),
});
